export default {
  api_http_url: 'https://webapp-api.flotas.strix.com.ar',
  api_username: 'PE2ysQGeeFu27U5r8dSvPjZMBXmJWcGC',
  api_password: 'A2nALPRjD7JavkprEb9gDvry3q4a6g9d',
  google_api_key: 'AIzaSyAVCEISirUj2z6G0ZRuzG-bPJtwKqeeqJE',
  wamp_realm_uri: 'com.magenta.public',
  api_wamp_url: 'wss://webapp-wamp.flotas.strix.com.ar/ws',
  tyc_landing_url_ar: 'http://landing.lojack.com.ar/strix_flotas/terminos',
  tyc_landing_url_cl: 'http://landing.lojack.com.ar/strix_flotas/terminos/indexch.html',
  tyc_landing_url_uy: 'http://landing.lojack.com.ar/strix_flotas/terminos/indexuy.html',
  apiKey: 'AIzaSyC__94M7jXuDBnL7Y2xF4_ITdWKEdvAVUs',
  authDomain: 'strix-flotas-prod.firebaseapp.com',
  projectId: 'strix-flotas-prod',
  storageBucket: 'strix-flotas-prod.appspot.com',
  messagingSenderId: '425604502965',
  appId: '1:425604502965:web:de178af230ef812dbc75fc',
  measurementId: 'G-WTT40Q79ZM'
}
